export default __webpack_public_path__ + "static/media/HConnectLogo_colored.ebfe3e42.svg";